// Speech bubble coaching prompt component
// Adapted from modals-ai-assistant-modal

import { Heading as AriaHeading } from "react-aria-components"

import CoachAvatar from "@/assets/images/coach/idle.png"

interface CoachingPromptsProps {
  userName?: string
  onPromptClick?: (prompt: string) => void
  currentStep?: number
  totalSteps?: number
  avatarSrc?: string
  question?: string
}

export const CoachingPrompts = ({
  onPromptClick,
  currentStep = 1,
  totalSteps = 5,
  avatarSrc = CoachAvatar,
  question = "What would you like help with?",
}: CoachingPromptsProps) => {
  const handleClick = (prompt: string) => {
    onPromptClick?.(prompt)
  }

  const prompts = [
    "Communicate my symptoms clearly",
    "Advocate for my experience",
    "Understand the diagnostic process",
  ]

  return (
    <div className="flex w-full max-w-3xl flex-col gap-5 p-6">
      {/* Avatar and Speech Bubble with Progress */}
      <div className="flex items-start gap-5">
        {/* Avatar */}
        <div className="flex-shrink-0">
          <div className="flex h-28 w-28 items-center justify-center overflow-hidden rounded-full border border-gray-200 bg-white shadow-sm">
            <img
              src={avatarSrc}
              alt="AI Assistant"
              className="h-full w-full object-cover"
            />
          </div>
        </div>

        {/* Speech Bubble and Progress Bar */}
        <div className="relative flex flex-1 flex-col gap-4">
          {/* Speech Bubble */}
          <div className="relative rounded-xl bg-gradient-to-br from-white to-gray-50 px-5 py-3.5 shadow-sm ring-1 ring-gray-900/5">
            <AriaHeading
              slot="title"
              className="text-sm leading-relaxed font-medium text-gray-900"
            >
              {question}
            </AriaHeading>
          </div>

          {/* Progress Dots */}
          <div className="flex items-center gap-2">
            {Array.from({ length: totalSteps }).map((_, index) => (
              <div
                key={index}
                className={`h-2 rounded-full transition-all duration-300 ${
                  index === currentStep
                    ? "bg-brand-600 w-10"
                    : "w-2 bg-gray-300"
                }`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Prompt Buttons - Cascading from left */}
      <div className="flex flex-col gap-3 pl-[8.25rem]">
        {prompts.map((prompt, index) => (
          <button
            key={index}
            onClick={() => handleClick(prompt)}
            className="text-brand-900 hover:bg-brand-50 hover:border-brand-300 focus-visible:ring-brand-600 w-fit cursor-pointer rounded-xl border border-gray-200 bg-white px-5 py-3 text-left text-sm font-medium shadow-sm transition-all focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none"
          >
            {prompt}
          </button>
        ))}
      </div>
    </div>
  )
}
